/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Camera_FlipInputs */

const en_us2_body_assessment_camera_flip = /** @type {(inputs: Body_Assessment_Camera_FlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch camera`)
};

const pt_br2_body_assessment_camera_flip = /** @type {(inputs: Body_Assessment_Camera_FlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar de câmera`)
};

const es_419_body_assessment_camera_flip = /** @type {(inputs: Body_Assessment_Camera_FlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar de cámara`)
};

const pt_pt2_body_assessment_camera_flip = /** @type {(inputs: Body_Assessment_Camera_FlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar de câmara`)
};

const fr_fr2_body_assessment_camera_flip = /** @type {(inputs: Body_Assessment_Camera_FlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer de caméra`)
};

const de_de2_body_assessment_camera_flip = /** @type {(inputs: Body_Assessment_Camera_FlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera wechseln`)
};

const it_it2_body_assessment_camera_flip = /** @type {(inputs: Body_Assessment_Camera_FlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia fotocamera`)
};

/**
* | output |
* | --- |
* | "Switch camera" |
*
* @param {Body_Assessment_Camera_FlipInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_camera_flip = /** @type {((inputs?: Body_Assessment_Camera_FlipInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Camera_FlipInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_camera_flip(inputs)
	if (locale === "es-419") return es_419_body_assessment_camera_flip(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_camera_flip(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_camera_flip(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_camera_flip(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_camera_flip(inputs)
	return en_us2_body_assessment_camera_flip(inputs)
});
export { body_assessment_camera_flip as "body-assessment.camera_flip" }